export default "__VITE_ASSET__Df12YMGF__"